<template>
  <div id="industry-list" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div class="page-tabs">
      <el-form :model="search" ref="search" style="margin-top: 10px">
        <el-row>
          <el-col :span="8">
            <el-form-item prop="title">
              <el-input
                prefix-icon="el-icon-search"
                v-model="search.title"
                style="width: 100%"
                placeholder="请输入政策名称"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" style="margin-left: 10px">
            <div>
              <el-button
                type="primary"
                icon="el-icon-search"
                @click="searchList"
                >查询
              </el-button>
              <el-button icon="el-icon-refresh-right" @click="handleClear()">
                重置刷新
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.label"
          :name="item.type"
          v-for="(item, index) in classifyList"
          :key="index"
        >
          <div class="laws-box" v-loading="loading">
            <div
              v-for="(item, index) in noticeList"
              :key="index"
              class="laws-li"
              @click="goUrl(item, index)"
              v-show="noticeList.length"
            >
              <div class="laws-li-l">
                <div class="laws-li-img">
                  <img src="../../assets/images/common/right-1.png" alt="" />
                </div>
                <span>{{ item.title ? transitionClean(item.title) : "" }}</span>
              </div>
              <div class="laws-li-r">
                {{ item.releaseTime }}
              </div>
            </div>
            <div v-show="!noticeList.length">
              <div class="park-list-table-no-c-img">
                <img src="@/assets/images/common/1.png" alt="" />
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="page-box" v-show="noticeList.length">
      <el-pagination
        :current-page="search.current"
        :page-sizes="[10, 20, 40, 80]"
        prev-text="上一页"
        next-text="下一页"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-size="search.size"
        layout=" prev, pager, next,total, jumper "
        :total="total"
      ></el-pagination>
    </div>
    <tools></tools>
  </div>
</template>
<script>
import {
  getTransferAnnouncementPage,
  plotPublicityPage,
  transferAnnouncementList,
  getPolicyPage,
  getNoticePage,
} from "@/api/setting/investment";
import Tools from "@/views/home/components/tools";
export default {
  name: "industryList",
  components: { Tools },
  data() {
    return {
      activeName: "1",
      search: {
        size: 10,
        current: 1,
        title: "",
      },
      noticeList: [],
      total: 0,
      classifyList: [
        { type: "1", label: "出让公告", isShow: true },
        { type: "2", label: "成交公示", isShow: false },
        { type: "3", label: "政策文件", isShow: false },
        // { type: "4", label: "土地要素保障政策", isShow: false },
        { type: "4", label: "新闻动态", isShow: false },
      ],
      loading: false,
      screenIndexWidth: null,
    };
  },
  watch: {
    activeName: function (val) {
      this.search.current = 1;
      this.getNotice();
    },
  },

  created() {
    window.addEventListener("keydown", this.handkeyCode, true); //开启监听键盘按下事件
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
    this.getNotice();
  },
  methods: {
    goUrl(item, index) {
      if (this.activeName != "4") {
        this.$router.push({
          name: "rtfPreviewDetail",
          params: item,
          index,
        });
      } else {
        if (item.noticeType == "01") {
          this.$router.push({
            name: "rtfPreviewDetail",
            params: item,
            index,
          });
        } else {
          window.open(item.otherUrl);
        }
      }
    },
    //去掉格式
    transitionClean(connet) {
      return connet.replace(/<(?!img|video).*?>/g, "");
    },
    searchList() {
      console.log("查询");
      this.search.current = 1;
      this.getNotice();
    },
    // 清除搜索
    handleClear() {
      console.log("清除");
      this.search.title = "";
      this.getNotice();
    },
    // handleClick() {
    //    this.search.current = 1;

    // },
    //切换页码
    handleCurrentChange(val) {
      console.log("切换页码");
      this.search.current = val;
      this.getNotice();
    },

    //切换页条数
    handleSizeChange(val) {
      console.log("切换页条数");
      this.search.size = val;
      this.getNotice();
    },
    //公告列表
    getNotice() {
      this.loading = true;
      if (this.activeName == 1) {
        this.search.policyLevel = 0;
        transferAnnouncementList(this.search).then((res) => {
          if (res.data.success) {
            this.total = res.data.data.total;
            let data = res.data.data.records;
            data.forEach((item) => {
              item.releaseTime = item.releaseTime
                ? item.releaseTime.slice(0, 10)
                : "";
            });
            this.noticeList = data;
            this.loading = false;
          }
        });
      }
      if (this.activeName == 2) {
        this.search.policyLevel = 0;
        plotPublicityPage(this.search).then((res) => {
          if (res.data.success) {
            this.total = res.data.data.total;
            let data = res.data.data.records;
            data.forEach((item) => {
              item.releaseTime = item.releaseTime
                ? item.releaseTime.slice(0, 10)
                : "";
            });
            this.noticeList = data;
            this.loading = false;
          }
        });
      }
      //
      if (this.activeName == 3) {
        // this.search.policyLevel = 1;
        let params = { type: 3 };
        params = { ...params, ...this.search };
        getNoticePage(params).then((res) => {
          if (res.data.success) {
            this.total = res.data.data.total;
            let data = res.data.data.records;
            data.forEach((item) => {
              item.releaseTime = item.releaseTime
                ? item.releaseTime.slice(0, 10)
                : "";
            });
            this.noticeList = data;
            this.loading = false;
          }
        });
        // this.total = 0;
        // this.noticeList = [];
        // this.loading = false;
        // console.log(111111111);
      }
      // 新闻动态
      if (this.activeName == 4) {
        // this.total = 0;
        // this.noticeList = [];

        let params = { type: 2, classify: "09" };
        params = { ...params, ...this.search };

        getNoticePage(params).then((res) => {
          if (res.data.success) {
            this.noticeList = res.data.data.records;
            this.total = res.data.data.total;
            this.loading = false;
          }
        });
      }
      // if(this.activeName==4){
      //   let params = {  };
      //   params = { ...params, ...this.search };
      //    getNoticePage(params).then((res) => {
      //     if (res.data.success) {
      //       this.noticeList = res.data.data.records;
      //       this.total = res.data.data.total;
      //     }
      //     this.loading = false;
      //   });

      // }
    },
    handkeyCode(e) {
      if (e.keyCode === 13) {
        console.log("回车时间");
        this.getNotice();
      }
    },
    handleClick(tab) {
      // console.log(parseInt(tab.index) +1);
      var index = parseInt(tab.index) + 1;
      var i = index.toString();

      // index =toString(index)
      // console.log(index);
      window.sessionStorage.setItem("activeNameIndex", i);
    },
  },
};
</script>

<style scoped>
#industry-list {
  min-height: calc(100% - 260px);
  width: 60%;
  margin: 0 auto;
  background: white;
  /* min-height: calc(100% - 326px);
  height: auto;
  display: inline-table; */
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* padding-bottom: 115px; */
}

.page-tabs {
  min-height: calc(100% - 80px);
  padding: 0 10px;
}

.laws-li {
  padding: 10px;
  display: flex;
  font-size: 0.95rem;
  font-weight: 600;
  /* width: 100%; */
  cursor: pointer;
  justify-content: space-between;
}

.laws-li-img {
  padding-right: 10px;
}

.laws-li:hover {
  border: 1px solid #eee;
  box-shadow: 0 0 10px #d3d2d2;
}

.laws-li:active {
  background-color: #00000010;
}

.laws-li-r {
  width: 200px;
  text-align: right;
  color: #b9b9b9;
}

.page-box {
  margin: 20px 0;
  display: flex;
  justify-content: center;
  /* position: sticky;
  bottom: 20px; */
}

.laws-li-img {
  padding-right: 10px;
}

.laws-li-l {
  width: calc(100% - 220px);
  display: flex;
}

.laws-li-l > span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

::v-deep .page-box .el-pager li {
  border: 1px solid #409eff;
}

::v-deep .el-pagination button:disabled {
  color: #fff;
  background: #409eff;
}

::v-deep .el-pagination .btn-prev {
  margin: 0 10px;
  padding-right: 8px;
}

::v-deep .el-pagination .btn-next {
  padding-left: 8px;
  margin: 0 10px;
}

::v-deep .el-pager li {
  padding: 0;
  margin: 0 4px;
}

::v-deep .el-tabs__item {
  font-size: 1rem;
}

.park-list-table-no-c-img {
  width: 300px;
  margin: 100px auto 50px;
}

.park-list-table-no-c-img > img {
  width: 100%;
}
</style>
